// extracted by css-extract-rspack-plugin
export default {"container":"McpDetails-module__container___vL74kf","content":"McpDetails-module__content__my3QGyr","hideOnDesktop":"McpDetails-module__hideOnDesktop__O435Rw9"};